export const Compliance = {
    gdprNoticeLabel: 'gdpr_notice_label',
    gdprNoticeInformation: 'gdpr_notice_information',
    gdprHowDoWeUseYourData: 'gdpr_how_do_we_use_your_data'
};
